import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

export interface BusinessArea {
  provinces: string[]
  region: string
}

interface BusinessAreasState {
  areas: BusinessArea
}

const initialState: BusinessAreasState = {
  areas: {
    provinces: [],
    region: '',
  },
}

const businessAreasSlice = createSlice({
  name: "businessAreas",
  initialState,
  reducers: {
    toggleProvince: (state, action: PayloadAction<string>) => {
      const { provinces } = state.areas;
      const index = provinces.indexOf(action.payload);
      if (index !== -1) {
        provinces.splice(index, 1); // Remove if exists
      } else {
        provinces.push(action.payload); // Add if not exists
      }
    },

    setRegion: (state, action: PayloadAction<string>) => {
      state.areas.region = action.payload;
    },

    selectAllProvinces: (state, action: PayloadAction<string[]>) => {
      const allSelected = action.payload.every((province) =>
        state.areas.provinces.includes(province)
      );
      state.areas.provinces = allSelected ? [] : [...new Set(action.payload)];
    },

    setProvinces: (state, action: PayloadAction<string[]>) => {
      state.areas.provinces = [...new Set(action.payload)];
    },

    resetBusinessAreas: (state) => {
      state.areas = initialState.areas;
    },
  },
})

export const { toggleProvince, setRegion, selectAllProvinces, resetBusinessAreas, setProvinces } = businessAreasSlice.actions
export default businessAreasSlice.reducer
